import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { i18n } from "./LandRentedNotification.i18n";
import { LandRentedIcon } from "../../../Icon";
import { IconBadge, IconBadgeIcon } from "../../../IconBadge";
import { NotificationItem } from "../../NotificationItem";
import { NotificationItemDescription, NotificationItemTitle, } from "../../NotificationItem.styled";
const LandRentedNotification = React.memo((props) => {
    const { notification, locale, renderProfile } = props;
    const tenant = renderProfile
        ? renderProfile(notification.metadata.tenant)
        : notification.metadata.tenant;
    return (_jsxs(NotificationItem, { image: _jsx(LandRentedIcon, {}), timestamp: notification.timestamp, isNew: !notification.read, locale: locale, children: [_jsx(NotificationItemTitle, { children: i18n[locale].title }), _jsxs(NotificationItemDescription, { color: "inherit", underline: "none", children: [i18n[locale].description.start, " ", _jsx(IconBadge, { inline: true, icon: IconBadgeIcon.Places, text: notification.metadata.land, onClick: () => window.open(notification.metadata.link, "_blank") }), " ", i18n[locale].description.end, " ", tenant] })] }));
});
export { LandRentedNotification };
//# sourceMappingURL=LandRentedNotification.js.map